"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconArrowLeft = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconArrowLeft = function SvgIconArrowLeft(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5626 5.24996L6.00585 1.80671C6.07558 1.73702 6.1309 1.65429 6.16866 1.56323C6.20642 1.47216 6.22587 1.37455 6.2259 1.27597C6.22594 1.17739 6.20656 1.07977 6.16886 0.988678C6.13117 0.897588 6.07591 0.814814 6.00622 0.745082C5.93654 0.67535 5.8538 0.620026 5.76274 0.582268C5.67168 0.544511 5.57407 0.525059 5.47549 0.525024C5.37691 0.52499 5.27928 0.544372 5.18819 0.582065C5.0971 0.619758 5.01433 0.675024 4.9446 0.744707L0.219598 5.46971C0.0789948 5.61035 7.62939e-06 5.80108 7.62939e-06 5.99996C7.62939e-06 6.19883 0.0789948 6.38956 0.219598 6.53021L4.9446 11.2552C5.01433 11.3249 5.0971 11.3802 5.18819 11.4178C5.27928 11.4555 5.37691 11.4749 5.47549 11.4749C5.67458 11.4748 5.86549 11.3957 6.00622 11.2548C6.07591 11.1851 6.13117 11.1023 6.16886 11.0112C6.20656 10.9201 6.22594 10.8225 6.2259 10.7239C6.22583 10.5248 6.14668 10.3339 6.00585 10.1932L2.5626 6.74996H11.2498C11.4488 6.74996 11.6395 6.67094 11.7802 6.53029C11.9208 6.38963 11.9998 6.19887 11.9998 5.99996C11.9998 5.80104 11.9208 5.61028 11.7802 5.46963C11.6395 5.32897 11.4488 5.24996 11.2498 5.24996H2.5626Z",
    fill: "currentColor"
  }));
};

exports.SvgIconArrowLeft = SvgIconArrowLeft;